import React from 'react';
import { WorkplaceWorkersStatus } from '../../../../Enums/WorkplaceWorkersStatus.enum';
import { Badge } from '../../../../../EArchive/Components/EArchiveListItem/EArchiveListItemStatusBadge';

interface Props {
	status: WorkplaceWorkersStatus;
}

const WorkplaceWorkersItemStatusBadge: React.FC<Props> = ({ status }) => {
	switch (status) {
		case WorkplaceWorkersStatus.PENDING_REGISTRATION:
			return (
				<Badge
					title='base.workplaceMemberStatus.pendingRegistration'
					className='gray'
				/>
			);
		case WorkplaceWorkersStatus.PENDING:
			return (
				<Badge title='base.workplaceMemberStatus.pending' className='gray' />
			);
		case WorkplaceWorkersStatus.ACCEPTED:
			return (
				<Badge title='base.workplaceMemberStatus.active' className='green' />
			);
	}

	return <></>;
};

export default WorkplaceWorkersItemStatusBadge;
